import { render, staticRenderFns } from "./ContratosAluguelVencidos.vue?vue&type=template&id=d4452812&"
import script from "./contratosAluguelVencidos.js?vue&type=script&lang=js&"
export * from "./contratosAluguelVencidos.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports